import { useEffect, useState } from "react";

export function useIsDark() {
  const [isDark, setIsDark] = useState(() => document.documentElement.classList.contains("dark"));
  useEffect(() => {
    const obs = new MutationObserver(() => setIsDark(document.documentElement.classList.contains("dark")));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);
  return isDark;
}

export function useChartColors() {
  const isDark = useIsDark();
  return isDark
    ? { grid: "#27272a", axis: "#71717a", tooltip: { background: "#0a0a0b", border: "1px solid #27272a", borderRadius: 4, color: "#fafafa" } }
    : { grid: "#e5e7eb", axis: "#9ca3af", tooltip: { background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: 4, color: "#18181b" } };
}
